var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"disclaimer"}},[_vm._v(" Нажимая кнопку “"+_vm._s(_vm.text)+"”,"),_c('br'),_vm._v(" вы соглашаетесь "),_c('a',{attrs:{"href":"https://docs.google.com/document/d/18ccRmhu1-tFramWheRfVQ4-iEGMckv7pKJm1pt-xSW0","target":"_blank"}},[_vm._v("с условиями использования")])])
}
var staticRenderFns = []

export { render, staticRenderFns }